import React, { KeyboardEvent } from 'react';
import classes from './searchText.module.scss';
import TextSearchInput from 'components/common/TextSearchInput/textSearchInput';
import { useHomeQuickLinks } from 'components/Mobile/pages/home/hooks/useHomeQuickLinks';

export const SearchText = () => {
    const [searchText, setSearchText] = React.useState('');
    const { goToQuickLink } = useHomeQuickLinks();

    const handleSearchClick = () => {
        if (searchText === '') return;
        goToQuickLink({ cardSearch: searchText });
    };

    const handleSearchEnterClick = (e: KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter' && searchText !== '') {
            goToQuickLink({ cardSearch: searchText });
        }
    };
    return (
        <TextSearchInput
            className={classes.searchBox}
            placeholder={'Search by activity name or id'}
            handleClear={() => {
                setSearchText('');
            }}
            onChange={(e) => {
                setSearchText(e.target.value);
            }}
            value={searchText}
            maxLength={300}
            handleClick={handleSearchClick}
            onKeyDown={handleSearchEnterClick}
        />
    );
};
